import { getSearchType } from '../../gtm/searchPageGtmBuildData'

const isSuggestQueryClick = (searchEvent: string): boolean => {
  return (
    searchEvent.includes('after-query-suggest') ||
    searchEvent.includes('pre-suggest')
  )
}

const isSearchSubmit = (searchEvent: string): boolean => {
  return searchEvent === 'search-submit'
}

/**
 * Build analyticsTags array for AlgoliaSearch on SERP
 *
 * @example
 * getSearchPageAlgoliaSearchAnalyticsTags('desktop', '?q=ibuprofen&i=1')
 * ['search', 'desktop', 'web', 'interne']
 */
export const getSearchPageAlgoliaSearchAnalyticsTags = (
  deviceType: string,
  searchParams: URLSearchParams,
): string[] => {
  const searchType = getSearchType(searchParams)
  const searchEvent = searchParams.get('eventName') ?? ''
  const analyticsTags = ['search', 'web', deviceType, searchType]

  if (isSuggestQueryClick(searchEvent)) {
    analyticsTags.push('suggest_query_click')
  }
  if (isSearchSubmit(searchEvent)) {
    analyticsTags.push('search_submit')
  }

  return analyticsTags
}
